const getInitialLocal = (customization) => {

  // getting stored items
  const savedLocale = localStorage.getItem("language");
  console.log(savedLocale || customization.locale)
  return savedLocale || customization.locale;
}

export default getInitialLocal
